import type { TOC } from '@ember/component/template-only';
import { or } from 'ember-truth-helpers';
import SettingsCentralMappingDropdownsDropdownCommissionable from 'lumen/components/settings/central-mapping/dropdowns/dropdown-commissionable';
import { TRIGGER_CENTRAL_MAPPING_VARIANTS } from 'lumen/components/settings/central-mapping/dropdowns/triggers/trigger-central-mapping';
import type { CentralMappingMappingEntryMarketSegment } from 'lumen/models';
import type { Commissionable } from 'lumen/models/central-mapping/mapping-entry-market-segment';

interface HotelSettingsCentralMappingTablesCellsTdCommissionableSignature {
  Args: {
    column: {
      isReadOnly?: boolean;
    };
    row: {
      mappingEntry: CentralMappingMappingEntryMarketSegment;
      setCommissionable: (value: Commissionable) => void;
    };
    rowMeta: {
      isSelected: boolean;
    };
  };
}

const HotelSettingsCentralMappingTablesCellsTdCommissionable: TOC<HotelSettingsCentralMappingTablesCellsTdCommissionableSignature> =
  <template>
    <div data-test-id="table-central-mapping-td-commissionable">
      <SettingsCentralMappingDropdownsDropdownCommissionable
        @autoCommissionable={{@row.mappingEntry.autoCommissionable}}
        @commissionable={{@row.mappingEntry.commissionable}}
        @isReadOnly={{or @column.isReadOnly @rowMeta.isSelected}}
        @isSelected={{@rowMeta.isSelected}}
        @setCommissionable={{@row.setCommissionable}}
        @userCommissionable={{@row.mappingEntry.userCommissionable}}
        @variant={{TRIGGER_CENTRAL_MAPPING_VARIANTS.SUBDUED}}
      />
    </div>
  </template>;

export default HotelSettingsCentralMappingTablesCellsTdCommissionable;
